// ============================================================================
// CANCUN100 — MisVentasB.js  (APP 2/20 · Mis ventas del agente idéntica al mockup aprobado: acordeón de vidrio, sin tabla)
// ----------------------------------------------------------------------------
// Referencia que manda: 30 App sistema/Prototipos/mis-ventas-y-mi-bolsa-2.0 (MOCKUP APROBADO).html · estilos en styles/glass.css.
// Cerrado: folio, estado con punto («3 de 3 confirmados»), cliente, «Viaja dd-mmm · servicios»; a la derecha total y «Tu comisión $X».
// Abierto: Pago del cliente · Servicios · píldoras (todo lo que hacía la fila de botones) + UN botón con el siguiente paso.
// ============================================================================
import React from 'react';
import { itemsDe, itemVivo, num } from './contabilidadV3';
import { esDepositoPrevioV2 } from './historial';
import { Dinero, Chev, Estado } from './MiBolsaB';

const F0 = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
const $t = (v) => `$${F0.format(Math.round(num(v)))}`;
const fechaCorta = (f) => { if (!f) return ''; try { const d = new Date(String(f).slice(0, 10) + 'T12:00:00'); return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' }).replace('.', ''); } catch { return String(f).slice(0, 10); } };
const fechaItem = (it) => String(it.hotel_checkin || it.fecha_actividad || it.fecha || it.vuelo_salida || '').slice(0, 10);
const ESTADO_ITEM = { confirmado: ['ok', 'Confirmado'], enviado: ['warn', 'Enviado'], pendiente: ['', 'Pendiente'], revisar: ['bad', 'Revisar'], cancelado: ['bad', 'Cancelado'], reemplazado: ['', 'Reemplazado'] };

export function KpisVentas({ semana, mes, lugar }) {
  const sub = (k) => `${k.n} reserva${k.n !== 1 ? 's' : ''} · comisión ${$t(k.comision)}`;
  return (
    <div className="gl-kpis">
      <div className="gl-kpi gl-glass"><div className="gl-lbl">Vendido esta semana</div><div className="gl-v"><Dinero v={semana.total} /></div><div className="gl-s">{sub(semana)}</div></div>
      <div className="gl-kpi gl-glass"><div className="gl-lbl">Vendido este mes</div><div className="gl-v"><Dinero v={mes.total} /></div><div className="gl-s">{sub(mes)}</div></div>
      {lugar && <div className="gl-kpi gl-glass"><div className="gl-lbl">Tu lugar</div><div className="gl-v gl-num">{lugar.pos ? `#${lugar.pos}` : '—'}</div><div className="gl-s">{lugar.de ? `de ${lugar.de} agentes esta semana` : 'Sin datos'}</div></div>}
    </div>
  );
}

// Estado del folio cerrado: cancelado · borrador · historial · «k de n confirmados».
export const estadoVenta = (s, items) => {
  if (s.cancelado) return ['bad', 'Cancelado'];
  if (s.estado === 'borrador') return ['', 'Borrador'];
  if (s.en_historial === true && s.reactivacion_estado !== 'aprobada') return ['', 'Pagado · versión 2.0'];
  const vivos = (items || []).filter(itemVivo); const n = vivos.length; const k = vivos.filter((it) => it.estado_reserva === 'confirmado').length;
  if (!n) return ['', 'Sin servicios'];
  if (s.op_estado === 'confirmada') return ['ok', `${n} de ${n} confirmados`];
  return [k === n ? 'ok' : k > 0 ? 'warn' : (vivos.some((it) => it.estado_reserva === 'enviado') ? 'warn' : ''), `${k} de ${n} confirmado${n !== 1 ? 's' : ''}`];
};

// s = fila de reporte_ventas · pagos = pagos_cliente del folio · links = [[etiqueta, fn]] · principal = [etiqueta, fn] | null · extra = nodo (correo)
export function FolioVenta({ s, pagos = [], links = [], principal = null, extra = null, abierto = false }) {
  const items = itemsDe({ servicios_detalle: s.cupon_items ?? s.servicios_detalle }).filter(itemVivo);
  const [estTipo, estTexto] = estadoVenta(s, items);
  const total = num(s.total), deposito = num(s.deposito);
  const prepagos = s.es_top_tours ? 0 : items.filter((it) => it.es_prepago).reduce((t, it) => t + num(it.subtotal_neto), 0);
  const abonos = (pagos || []).filter((p) => !p.es_deposito_inicial).reduce((t, p) => t + num(p.monto), 0);
  const balance = Math.max(0, total - deposito - abonos);
  const previo = esDepositoPrevioV2(s, pagos);
  const viaja = s.fecha_cancun || s.fecha_reserva; const hoy = new Date().toISOString().slice(0, 10);
  const nombres = items.map((it) => it.nombre).filter(Boolean).join(', ');
  const click = (f) => (e) => { e.preventDefault(); e.stopPropagation(); f(); };
  return (
    <details className="gl-f gl-glass" open={abierto || undefined} style={{ opacity: s.cancelado ? .55 : 1, borderRight: s.es_rp_por_fuera ? '3px solid var(--au-purple-fg)' : undefined }}>
      <summary>
        <div style={{ minWidth: 0 }}>
          <span className="gl-folio">{s.folio}</span><Estado tipo={estTipo}>{estTexto}</Estado>
          {s.excluir_metricas && <Estado>Fuera de métricas</Estado>}
          <div className="gl-cli">{s.cliente || s.nombre || '—'}</div>
          <div className="gl-meta" title={nombres}>{viaja ? `${String(viaja).slice(0, 10) < hoy ? 'Viajó' : 'Viaja'} ${fechaCorta(viaja)}` : ''}{nombres ? ` · ${nombres}` : ''}</div>
        </div>
        <div className="gl-right">
          <div className="gl-v"><Dinero v={total} /></div><div className="gl-l">Tu comisión {$t(s.comision)}</div>
          <Chev />
        </div>
      </summary>
      <div className="gl-inner">
        <div className="gl-cols">
          <div className="gl-blk"><div className="gl-lbl">Pago del cliente</div>
            <div className="gl-kv">
              <span>Total de la venta</span><span>{$t(total)}</span>
              <span>Depósito</span><span>{$t(deposito)}</span>
              {prepagos > 0 && <><span>Prepagos</span><span>{$t(prepagos)}</span></>}
              {abonos > 0 && <><span>Abonos</span><span>{$t(abonos)}</span></>}
              <span className="gl-tot">Balance</span><span className="gl-tot">{$t(balance)}</span>
            </div>
            {previo && <div className="gl-nota">Depósito registrado antes de la versión 2.0.</div>}
          </div>
          <div className="gl-blk"><div className="gl-lbl">Servicios</div>
            {items.length === 0 ? <div className="gl-nota">Sin servicios.</div> : (
              <div className="gl-items">
                {items.map((it, i) => { const [t, l] = ESTADO_ITEM[it.estado_reserva] || ESTADO_ITEM.pendiente; return <div key={it.item_id || i} className="gl-it"><span>{fechaItem(it) ? fechaCorta(fechaItem(it)) + ' · ' : ''}{it.nombre}</span><Estado tipo={t} m0>{l}</Estado></div>; })}
              </div>
            )}
          </div>
        </div>
        <div className="gl-acts">
          <div className="gl-links">{links.map(([l, f]) => <button key={l} type="button" className="gl-lnk" onClick={click(f)}>{l}</button>)}{extra}</div>
          {principal && <button type="button" className="gl-btn" onClick={click(principal[1])}>{principal[0]}</button>}
        </div>
      </div>
    </details>
  );
}
